import { render, staticRenderFns } from "./WeeklySales.vue?vue&type=template&id=1664db53&scoped=true"
import script from "./WeeklySales.vue?vue&type=script&lang=js"
export * from "./WeeklySales.vue?vue&type=script&lang=js"
import style0 from "./WeeklySales.vue?vue&type=style&index=0&id=1664db53&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1664db53",
  null
  
)

export default component.exports